export default __webpack_public_path__ + "static/media/item-2.fb93bba9.webp";